import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'

import ImgBox from '../../components/Gamification/ImgBox'
import CreatNft from '../../components/Gamification/CreatNft'
import {Info} from '../../components/Gamification/InfoBox'
import { RowColumn } from '../../components/Row'

import { NFTTYPE } from '../../constants/bakery/nft'

import useNodeBlock from '../../hooks/ido/useNodeBlock'

const GameMain = styled.div`
  width: 890px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `};
`
const Main = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    justify-content: center;
  `};
`

export default function GameBox () {

  // 当前区块
  const curNum = useNodeBlock()

  return (
    <GameMain>
      <Main>
        <ImgBox imgLink={'/images/nft/gamebox.png'}/>
        <RowColumn>
          <CreatNft type={NFTTYPE.GAMEBOX} curNum={curNum} />
          <Info style={{height: '290px'}}>
            <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>What are BSC Game Boxes?</Text>
            <Text fontSize={14} marginTop={20}>1. A BSC Game Box corresponds to a package of top NFT Game tokens on the Binance Smart Chain.</Text>
            <Text fontSize={14} marginTop={20}>2. You can get a BSC Game Box if you choose to burn 0.25 SOCCER token OR 0.25 POKER token here.</Text>
            <Text fontSize={14} marginTop={20}>3. By opening a BSC Game Box, you can immediately get 1500 TLM + 20 ALICE + 20 PET tokens, whose total value is more than 1 BNB.</Text>
            <Text fontSize={14} marginTop={20}>4. TLM / ALICE / PET are the utility tokens for the NFT game projects of Alien Worlds / My Neighbor Alice / Battle Pets, respectively. TLM and ALICE have been listed on Binance. Battle Pets is listed on Gate.io and Bakeryswap.</Text>
            <Text fontSize={14} marginTop={20}>5. You can also stake the BSC Game Box to earn TLM tokens for the next 10 days, with a rather high APY!</Text>
            <Text fontSize={14} marginTop={20}>6. Each address is limited to buy only 2 BSC Game Boxes, 1 for 0.25 SOCCER and 1 for 0.25 POKER.</Text>
          </Info>
        </RowColumn>
      </Main>
    </GameMain>
  )
}
